module.exports = __webpack_public_path__ + "static/media/IconCogSvg.a1ef6978.svg";